export * from './ticket';



// WEBPACK FOOTER //
// ./src/app/data/models/transaction/op/outbound/ticket/index.ts